<template>
  <div class="header">
    <div
      v-if="baseinfo.comname"
      class="inner clearfix"
    >
      <a
        :href="`/organization/project?cid=${baseinfo.cid}&type=inquery`"
        class="left fl clearfix"
      >
        <!-- :src="`${baseinfo.logo}`" -->
        <span class="fl logo-icon">
          <img
            v-if="logo"
            :src="logo"
            alt="logo"
          >
        </span>
        <span class="project-name fl">{{ baseinfo.comname }} | {{ baseinfo.projectname }}</span>
      </a>
      <a-tag
        v-if="!$isDingDing"
        class="inquery-head-tag"
      >
        询盘管理
      </a-tag>
      <div class="fl service-tip-box">
        <span
          v-if="baseinfo.is_display_vipused === 1"
          class="open-service-tip"
          @click="openHandler"
        >{{ $t('message["355"]') }} <i /></span>
        <template v-if="baseinfo.countdown_vipused>0">
          <template v-if="baseinfo.system_role === 1">
            <span class="limit-time-tip">{{ serviceExpressTip2[0] }}{{ baseinfo.countdown_vipused }}{{ serviceExpressTip2[1] }}</span>
            <a-button
              type="primary"
              size="small"
              @click="toService"
            >
              {{ $t('message["1050"]') }}
            </a-button>
          </template>
          <span
            v-else
            class="limit-time-tip"
          >{{ serviceExpressTip3[0] }}{{ baseinfo.countdown_vipused }}{{ serviceExpressTip3[1] }}</span>
        </template>
        <template v-if="baseinfo.system_role === 1">
          <span
            v-if="baseinfo.high_residue_day>0 && (baseinfo.countdown_vipused === 0)"
            class="open-service-tip2"
            :class="{'limit-time-tip':baseinfo.high_residue_day<=7}"
          >{{ serviceExpressTip[0] }}{{ baseinfo.high_residue_day }}{{ serviceExpressTip[1] }}</span>
        </template>
      </div>
      <expen-service ref="expenservice" />
      <div class="right-tool-box right fr clearfix">
        <!-- <div class="new-enrance fl">
          <a
            href="https://wj.qq.com/s2/5423892/5431/"
            target="_blank"
            class="ant-btn ant-btn-default"
          ><i class="iconfont icontiaoyan" />用户满意度调查</a>
        </div> -->
        <i
          v-if="isNewFeature"
          class="new-feature-icon iconfont iconnew1"
          @click="getNewCon"
        />
        <div
          class="message fl"
          @mouseenter.stop="noticeH(true)"
          @mouseleave.stop="noticeH(false)"
        >
          <template>
            <em
              v-if="baseinfo.unread_notice_num"
              class="num"
            >
              {{ baseinfo.unread_notice_num* 1> 99 ?'99+': baseinfo.unread_notice_num }}
            </em>
            <span
              v-else
              class="message-icon"
            >
              <i class="iconfont iconicon-test23" />
            </span>
          </template>
          <notice
            v-show="isNShow"
            @closeNoticeDialog="closeNoticeDialog"
          />
        </div>
        <header-dropdown />
      </div>
    </div>
    <new-feature-dialog ref="newFeatureTip" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Notice from './Notice'
import HeaderDropdown from './HeaderDropdown'
import ExpenService from '@/components/pc/serviceup/ExpenService'
import NewFeatureDialog from './NewFeatureDialog'

export default {
  components: {
    Notice,
    HeaderDropdown,
    ExpenService,
    NewFeatureDialog
  },
  data () {
    return {
      isNShow: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('newFeature', ['newFeatureInfo']),
    logo () {
      return this.baseinfo.logo
    },
    isNewFeature () {
      return this.baseinfo.announce
    },
    serviceExpressTip () {
      return this.$t('message["678"]').split('|')
    },
    serviceExpressTip2 () {
      return this.$t('message["679"]').split('|')
    },
    serviceExpressTip3 () {
      return this.$t('message["680"]').split('|')
    }
  },
  inject: ['reload'],
  methods: {
    ...mapActions('newFeature', ['getNewFeatureInfo']),
    noticeH (b) {
      this.isNShow = b
    },
    closeNoticeDialog () {
      this.isNShow = false
      this.baseinfo.unread_notice_num = 0
    },
    openHandler () {
      this.$refs.expenservice.changeVisible(true)
    },
    toService () {
      this.$router.push({ name: 'ServiceSuper' })
    },
    async getNewCon () {
      const { newFeatureInfo } = this
      if (!newFeatureInfo) {
        const chain = await this.getNewFeatureInfo()
        chain.onSuccess(raw => {
          this.$refs.newFeatureTip.changeLimitDialog(true)
        })
      } else {
        this.$refs.newFeatureTip.changeLimitDialog(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header::v-deep {
  min-height: 56px;
  line-height: 56px;
  background-color: #fff;
  border-bottom: solid 1px $gray4;
  .inner {
    max-width: 1280px;
    margin: 0 auto;
    .inquery-head-tag {
      margin: 16px 0 0 10px;
      float: left;
    }
    .service-tip-box {
      margin-left: 10px;
      .open-service-tip {
        color: #5077aa;
        cursor: pointer;
        i {
          background:url('../../assets/images/serviceupico.png') 0 0 no-repeat;
          width: 20px;
          height: 21px;
          background-size: 20px 21px;
          display: inline-block;
          // vertical-align: middle;
        }
      }
      .open-service-tip2 {
        color: #b3b3b3;
      }
      .limit-time-tip {
        color: #f57676 !important;
        margin-right: 10px;
      }
      .ant-btn-sm{
        font-size: 12px;
        padding: 0 8px;
      }
    }
  }
  .right-tool-box {
  }
  .logo-icon {
    min-width: 32px;
    margin: 0 8px 0 2px;
    font-size: 0;
    color: $primary-color;
    img {
      height: 32px;
      // margin-top: -2px;
      vertical-align: middle;
    }
  }
  .project-name {
    font-size: 18px;
    color: #333;
  }
  .new-enrance {
    .icontiaoyan {
      color: #1296db;
      font-size: 20px;
      vertical-align: middle;
      margin-right: 4px;
    }
    a {
      color: #666;
    }
  }
  .message {
    position: relative;
    margin-right: 16px;
    .message-icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: #f7f7f7;
      border-radius: 16px;
      cursor: pointer;
      .iconfont {
        font-size: 18px;
        color: $gray2;
      }
    }
    .num {
      // position: relative;
      // top: -7px;
      // left: -7px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      font-size: 14px;
      font-style: normal;
      background-color: $danger-color;
      border-radius: 50%;
      display: inline-block;
      text-align: center;
    }
  }
   .new-feature-icon {
    float: left;
    color: #4CA0F2;
    font-size: 32px;
    margin-right: 16px;
    cursor: pointer;
  }
  .arrow-icon {
    margin-left: 7px;
    color: #ccc;
  }
}
@media screen and (max-width: 1200px) {
  .header .inner {
    padding: 0 20px;
  }
}
</style>
